<!--
    描述：菜单
    时间：2021-04-09
    Created by zwh
-->
<template>
    <div class="h100">
        <div class="w-page-main">
            <div class="w-page-header superiors-search-area">
                <div class="left-text overflow-hidden">
                    <span><b>菜单列表</b></span>
                </div>
                <div class="btnGroups">
                    <el-button type="success" size="small" icon="el-icon-check"
                               v-if="roleBtns.includes('menu_permission_plus_save')" @click="saveClick('roleMenu')">保存
                    </el-button>
                </div>
            </div>
            <div class="w-page-container pdb10">
                <div class="w-table-layout">
                    <div class="w-table-content" ref="menusContent" style=" overflow-y: auto; border:1px solid #eee">
                        <el-tree ref="menusTree"
                                 :height="menusTreeData.tableH"
                                 :data="menusTreeData.tableData"
                                 :props="defaultProps"
                                 :expand-on-click-node="false"
                                 :highlight-current="true"
                                 default-expand-all
                                 show-checkbox
                                 :check-strictly="true"
                                 node-key="id"
                                 :default-checked-keys="treeDefaultCheckedKey"
                                 @node-click="nodeClick"
                        ></el-tree>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapState} from 'vuex'
    import {selectTree} from 'api/system/menu.js'
    import {getRoleMenuByRoleId, saveOrUpdateRoleMenu, getLimitMenu} from 'api/system/role.js'

    export default {
        components: {},
        data() {
            return {
                //角色id
                roleId: '',
                //树默认选中信息
                treeDefaultCheckedKey: [],
                btnLoading: false,
                //限制的菜单id信息
                limitMenuIdList: [],
                menusTreeData: {
                    loading: false,
                    tableH: 200,
                    tableData: [],

                    tableOriData: [],
                    tableByRoleData: [],
                },
                defaultProps: {
                    children: 'children',
                    label: 'sname'
                },
            }
        },
        mounted() {
            this.$nextTick(() => {
                setTimeout(() => {
                    this.menusTreeData.tableH = this.$refs.menusContent.offsetHeight;
                }, 100)
            })
        },
        computed: {
            ...mapState('app', {clientSize: state => state.clientSize}),
            ...mapState('menu', {
                roleBtns: state => state.roleBtns
            })
        },
        watch: {
            clientSize(val) {
                this.menusTreeData.tableH = this.$refs.menusContent.offsetHeight;
            }
        },
        created() {
            //this.initData()
            //获取菜单信息
            this.getMenuTreeTableData();
        },
        methods: {
            //初始化方法
            initData() {
                this.limitMenuIdList = []
                //获取限制的菜单信息
                this.getLimitMenus().then(val => {
                    this.getMenuTreeTableData();
                });
            },
            //获取菜单信息
            getMenuTreeTableData() {
                let that = this
                selectTree({isSys: 0}).then(res => {
                    if (res.operationCode == 1) {
                        that.menusTreeData.tableOriData = res.data;
                        that.menusTreeData.tableData = that.menusTreeData.tableOriData.concat();
                    }

                    if (this.menusTreeData.tableOriData.length > 0) {
                        // this.nodeClick(this.menusTreeData.tableOriData[0])
                        this.$refs.menusTree.setCurrentKey(this.menusTreeData.tableOriData[0].id)
                    }
                });

            },
            //获取菜单信息
            getMenuTreeInfoPlus(obj) {
                this.menusTreeData.tableData = this.menusTreeData.tableOriData.concat()
                this.getLimitMenus(obj)
                this.getMenuTreeInfoByRoleId(obj)
            },
            //获取限制的菜单信息
            getLimitMenus(obj) {
                let that = this
                let param = {
                    id: obj.id
                }
                this.limitMenuIdList = []
                getLimitMenu(param).then(res => {
                    if (res.operationCode == 1) {
                        if (res.data != null) this.limitMenuIdList = res.data.concat()
                        if (this.limitMenuIdList.filter(id => id == -1).length > 0) return
                        let menuTreeArray = that.$utils.toTreeArray(this.menusTreeData.tableData)
                        menuTreeArray = menuTreeArray.map(prop => {
                            let disabled = typeof (that.limitMenuIdList.find(menuId => {
                                return menuId == prop.id
                            })) != 'undefined' ? false : true
                            return {...prop, disabled: disabled}
                        })
                        that.menusTreeData.tableData = that.$utils.toArrayTree(menuTreeArray).concat()

                        if (this.menusTreeData.tableData.length > 0) {
                            // this.nodeClick(this.menusTreeData.tableData[1])
                            console.log(this.$refs.menusTree.setCurrentNode)
                            console.log(this.menusTreeData.tableData[1].id)
                            this.$refs.menusTree.setCurrentKey(this.menusTreeData.tableData[1].id)
                        }
                    }
                })
            },
            //根据角色id，获取菜单信息
            getMenuTreeInfoByRoleId(obj) {
                let that = this
                that.menusTreeData.tableData = that.menusTreeData.tableOriData.concat()
                that.roleId = obj.id
                that.treeDefaultCheckedKey = []
                let param = {roleId: obj.id}
                getRoleMenuByRoleId(param).then(res => {
                    if (res.operationCode == 1) {
                        that.treeDefaultCheckedKey = res.data
                    }
                });
            },
            //保存
            saveClick() {
                let that = this
                if (that.roleId == '') {
                    that.$message({message: '请选择角色信息', type: 'warning'});
                    return;
                }

                let menuIdsSelection = [];
                let checkSelection = this.$refs.menusTree.getCheckedKeys().concat()
                let param = {
                    roleId: that.roleId,
                    menuIdsSelection: checkSelection
                }
                console.log(" param-menuIds = " + param.menuIdsSelection);
                saveOrUpdateRoleMenu(param).then(res => {
                    if (res.operationCode == 1) {
                        that.$message({message: '保存成功', type: 'success'});
                    }
                });
            },
            //节点点击
            nodeClick(obj) {
                this.$emit('row-click', obj)
            },
        }
    }
</script>
<style lang="less" scoped>
    .tree-content {
        overflow-y: auto;
        padding: 5px 0px;
    }

    .w-table-page {
        padding-bottom: 5px;
    }
</style>